import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { push } from 'connected-react-router';
import {
  createStyles,
  ListItem,
  makeStyles, Theme,
} from '@material-ui/core';
import clsx from 'clsx';

import noop from '../../utility/noop';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    cursor: 'pointer',
    color: palette.publicNavBar.color,
    '&:hover': {
      backgroundColor: 'initial',
      textDecoration: 'none',
      color: palette.publicNavBar.hover,
    },
  },
  gutters: {
    paddingLeft: '24px',
    paddingRight: '24px',
  },
  text: {
    fontWeight: 600,
    width: '100%',
  },
  active: {},
}), { name: 'PagesMainBarDrawerLink' });

type Props = {
  to?: string;
  children?: React.ReactNode;
  className?: string;
  disableGutters?: boolean;

  onClick?: React.MouseEventHandler;
};

const PagesMainBarDrawerLink = ({
  to,
  children = null,
  className,
  disableGutters = false,
  onClick = noop,
}: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const clickHandler = useCallback((e: React.MouseEvent) => {
    onClick(e);

    if (!e.defaultPrevented && to) {
      dispatch(push(to));
    }
  }, [onClick, to, dispatch]);

  const active = useRouteMatch(to ?? '') && to;

  return (
    <ListItem
      classes={{
        root: clsx(className, classes.root, {
          [classes.active]: active,
        }),
        gutters: classes.gutters,
      }}
      onClick={clickHandler}
      disableGutters={disableGutters}
    >
      <span className={classes.text}>
        {children}
      </span>
    </ListItem>
  );
};

export default PagesMainBarDrawerLink;
